import type { GetAlphaDesignTypesResponse } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { designTypesKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetAlphaDesignTypes(): UseQueryResult<GetAlphaDesignTypesResponse> {
  return useQuery<GetAlphaDesignTypesResponse>({
    queryFn: async () =>
      await apiClient.url("/design-types/alpha").get().json(),
    queryKey: designTypesKeys.alpha(),
    retry: 2,
  });
}
